import { post } from "@/utils/api";
import { cooKeys, getCookie, setCookie } from "goi_common";
import { estimateEngOption } from "@/utils/getEstimatePath";
import { atom, selector } from "recoil";
import { SangjoOptionName } from "types/sangjoOptionName";

export interface Estimate {
  user: {
    created_at: string;
    is_conducted: boolean;
    is_consulted: boolean;
    is_signed: boolean;
    key: string;
    name: string;
    phone: string;
    updated_at: string;
  };
  "상조 서비스": {
    is_answered: boolean;
    type: SangjoOptionName;
    results: {
      [key: string]: {
        charge: number;
        detail: string;
        has_alpha: boolean;
      };
    };
    sum: number;
  };
  장례식장: {
    is_answered: boolean;
    name: string;
    results: {
      [key: string]: {
        charge: number;
        detail: string;
        has_alpha: boolean;
      };
    };
    sum: number;
  };
  장지: {
    is_answered: boolean;
    is_hwajang: boolean;
    name: {
      crematorium: string;
      jangji: string;
    };
    results: {
      [key: string]: {
        charge: number;
        detail: string;
        has_alpha: boolean;
      };
    };
    sum: number;
  };
}

export const estimateState = atom<Estimate | undefined>({
  key: "estimateState",
  default: undefined,
});

export const estimateErrorState = atom<boolean>({
  key: "estimateErrorState",
  default: false,
});

export const estimateKeyState = atom<string | undefined>({
  key: "estimateKeyState",
  default: undefined,
  effects: [
    ({ setSelf }) => {
      if (process.browser) {
        const key = getCookie(cooKeys.estimate_key);
        if (key) {
          setSelf(key);
        } else {
          post("/estimates/").then((res) => {
            setCookie(cooKeys.estimate_key, res.key);
            setSelf(res.key);
          });
        }
      }
    },
  ],
});

export const estimateLoadingState = atom<boolean>({
  key: "estimateLoadingState",
  default: false,
});

export const estimateLoadingTypeState = atom<estimateEngOption | "reset">({
  key: "estimateLoadingTypeState",
  default: "reset",
});

export const estimateForwardSnackbarState = atom<boolean>({
  key: "estimateForwardSnackbarState",
  default: false,
});

export const estimateCompletedState = selector<boolean>({
  key: "estimateCompletedState",
  get: ({ get }) => {
    const estimate = get(estimateState);
    return Boolean(
      estimate &&
        estimate["상조 서비스"].is_answered &&
        estimate.장례식장.is_answered &&
        estimate.장지.is_answered,
    );
  },
});

export const estimateCompletedPercentState = selector<number>({
  key: "estimateCompletedPercentState",
  get: ({ get }) => {
    const estimate = get(estimateState);
    let count = 0;

    if (estimate) {
      if (estimate["상조 서비스"].is_answered) count++;
      if (estimate.장례식장.is_answered) count++;
      if (estimate.장지.is_answered) count++;

      if (count === 1) {
        return 33;
      } else if (count === 2) {
        return 66;
      } else if (count === 3) {
        return 100;
      }
    }

    return 0;
  },
});

export const estimateSumState = selector<number>({
  key: "estimateSumState",
  get: ({ get }) => {
    const estimate = get(estimateState);
    let sum = 0;
    if (estimate) {
      if (estimate["상조 서비스"].is_answered) {
        sum += estimate["상조 서비스"].sum;
      }
      if (estimate.장례식장.is_answered) {
        sum += estimate.장례식장.sum;
      }
      if (estimate.장지.is_answered) {
        sum += estimate.장지.sum;
      }
    }

    return sum;
  },
});
